import { render, staticRenderFns } from "./DeluxeLeft.vue?vue&type=template&id=cf2316a8&"
import script from "./DeluxeLeft.vue?vue&type=script&lang=js&"
export * from "./DeluxeLeft.vue?vue&type=script&lang=js&"
import style0 from "./DeluxeLeft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports